import { render, staticRenderFns } from "./record.vue?vue&type=template&id=adaaa1aa&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=adaaa1aa&prod&lang=scss&scoped=true"
import style1 from "./record.vue?vue&type=style&index=1&id=adaaa1aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaaa1aa",
  null
  
)

export default component.exports